import { render } from "./flash-card-loading.vue?vue&type=template&id=8d90c4e2&scoped=true"
import script from "./flash-card-loading.vue?vue&type=script&lang=js"
export * from "./flash-card-loading.vue?vue&type=script&lang=js"

import "./flash-card-loading.vue?vue&type=style&index=0&id=8d90c4e2&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d90c4e2"]])

export default __exports__